/**
 * @module ol/layer/TileProperty
 */

/**
 * @enum {string}
 */
export default {
  PRELOAD: 'preload',
  USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};

//# sourceMappingURL=TileProperty.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/ol/layer/TileProperty.js
// module id = ../../../../ol/layer/TileProperty.js
// module chunks = 3